import {useEffect, useRef, useState} from "react";

import {LeasePackageCatalogSummaryDto} from "../../model/LeasePackageCatalog";
import {customAxios} from "../customAxios";

export function useGetLeasePackageCatalogs() {
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<LeasePackageCatalogSummaryDto[]>();
    const [error, setError] = useState<Error>();
    const latestRequest = useRef(0);

    useEffect(() => {
        execute().catch(() => undefined);
    }, []);

    async function execute() {
        const request = ++latestRequest.current;
        try {
            setLoading(true);
            setError(undefined);
            const catalogs = await getLeasePackageCatalogs();
            if(request === latestRequest.current) setData(catalogs);
            return catalogs;
        } catch (e) {
            if(request === latestRequest.current) setError(e as Error);
            return Promise.reject(e);
        } finally {
            if(request === latestRequest.current) setLoading(false);
        }
    }

    return {loading, data, error, execute};
}

export async function getLeasePackageCatalogs(): Promise<LeasePackageCatalogSummaryDto[]> {
    const response = await customAxios.get<LeasePackageCatalogSummaryDto[]>("/v1/lease-package-catalogs");
    return response.data;
}
